module.exports = __webpack_public_path__ + "img/Group 9743.2064179a.svg";